import type { MedplumClient } from '@medplum/core';
import type { Group } from '@medplum/fhirtypes';

import { GROUP_THERAPY_TAG_CODE, GROUP_THERAPY_TAG_SYSTEM } from '@unify/fhir-model/constants';
import {
  isTherapyCohortGroup,
} from '@unify/fhir-model/resources/group';

const THERAPY_GROUP_TAG = `${GROUP_THERAPY_TAG_SYSTEM}|${GROUP_THERAPY_TAG_CODE}`;

export async function searchTherapyGroups(
  medplum: MedplumClient,
  opts?: { organizationId?: string; activeOnly?: boolean },
): Promise<Group[]> {
  const params: Record<string, string> = {
    _tag: THERAPY_GROUP_TAG,
    _count: '100',
    _sort: '-_lastUpdated',
  };
  if (opts?.organizationId) {
    params['managing-entity'] = `Organization/${opts.organizationId}`;
  }
  // Medplum does not index Group.active — filter client-side after fetch.
  const results = await medplum.searchResources('Group', params);
  const therapyGroups = results.filter(isTherapyCohortGroup);
  if (opts?.activeOnly) {
    return therapyGroups.filter((g) => g.active !== false);
  }
  return therapyGroups;
}
